export const safeBrowserStorage = () => {
  if (typeof window === 'undefined') return undefined;
  try {
    const t = '__z__';
    window.localStorage.setItem(t, t);
    window.localStorage.removeItem(t);
    return window.localStorage;
  } catch {
    return undefined;
  }
};
